import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import { ToastProvider } from './ToastContext';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Verify from './pages/Verify';
import Forgot from './pages/Forgot';
import Reset from './pages/Reset';
import AcceptInvite from './pages/AcceptInvite';
import Welcome from './pages/Welcome';
import Mailbox from './pages/Mailbox';
import Inbox from './pages/Inbox';
import RFQDetail from './pages/RFQDetail';
import Suppliers from './pages/Suppliers';
import SupplierBehavior from './pages/SupplierBehavior';
import Customers from './pages/Customers';
import Dashboard from './pages/Dashboard';
import AdminUsers from './pages/AdminUsers';
import Settings from './pages/Settings';
import MailboxConnector from './pages/MailboxConnector';
import DataRetention from './pages/DataRetention';

function Private({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="empty">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/verify" element={<Verify />} />
            <Route path="/forgot" element={<Forgot />} />
            <Route path="/reset" element={<Reset />} />
            <Route path="/accept-invite" element={<AcceptInvite />} />
            <Route path="/welcome" element={<Private><Welcome /></Private>} />
            <Route path="/mailbox" element={<Private><Mailbox /></Private>} />
            <Route path="/inbox" element={<Private><Inbox /></Private>} />
            <Route path="/rfq/:id" element={<Private><RFQDetail /></Private>} />
            <Route path="/rfq/:id/:tab" element={<Private><RFQDetail /></Private>} />
            <Route path="/suppliers" element={<Private><Suppliers /></Private>} />
            <Route path="/suppliers/:id" element={<Private><SupplierBehavior /></Private>} />
            <Route path="/customers" element={<Private><Customers /></Private>} />
            <Route path="/dashboard" element={<Private><Dashboard /></Private>} />
            <Route path="/team" element={<Private><AdminUsers /></Private>} />
            <Route path="/settings" element={<Private><Settings /></Private>} />
            <Route path="/settings/email-inbox" element={<Private><MailboxConnector /></Private>} />
            <Route path="/settings/data-retention" element={<Private><DataRetention /></Private>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
